@if (searchIsVisible()) {
    <interacta-input-search
        class="mb-16 block shrink-0"
        [control]="searchControl"
        [iconPosition]="'right'"
    />
}

<interacta-radio-group
    class="block overflow-y-auto"
    [ngClass]="{
        'h-252 lg:h-308 xl:h-384': searchIsVisible(),
        'h-282 lg:h-340 xl:h-450': !searchIsVisible(),
    }"
    [ngModel]="selectedLink()"
    (ngModelChange)="onSelectionChange($event)"
>
    @for (link of filteredInverseLinks(); track link.id) {
        <interacta-radio-button [value]="link">
            {{ link.name }}
        </interacta-radio-button>
    } @empty {
        <interacta-no-result
            [imageName]="'no-results'"
            [size]="'small'"
            [subtitle]="true"
            [title]="true"
        />
    }
</interacta-radio-group>

<interacta-dialog-buttons class="shrink-0">
    <button
        interacta-dialog-button
        type="button"
        [label]="'RELATIONS_DIALOG.BACK_BUTTON' | translate"
        [style]="'text'"
        (click)="back.emit()"
    ></button>
    @let selectedLinkValue = selectedLink();
    <button
        interacta-dialog-button
        type="button"
        [disabled]="selectedLink() == null"
        [label]="'RELATIONS_DIALOG.COMMUNITY.SUBMIT' | translate"
        [style]="'filled'"
        (click)="
            selectedLinkValue && selectLink.emit({ link: selectedLinkValue })
        "
    ></button>
</interacta-dialog-buttons>
